import { jsx as f } from "react/jsx-runtime";
import { forwardRef as m } from "react";
import { twMerge as t } from "tailwind-merge";
const l = m(
  ({ className: r, ...o }, e) => /* @__PURE__ */ f(
    "div",
    {
      ref: e,
      className: t("h-2 w-2 flex-shrink-0 rounded-full", r),
      ...o
    }
  )
);
export {
  l as Dot
};
